var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copitext-cell"},[_c('span',{on:{"click":_vm.handlerClick}},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"copy-box",on:{"click":_vm.handlerCopy}},[_c('i',{staticClass:"el-icon-document-copy"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }